import React, { useState, useEffect } from 'react'
import { Link, useParams  } from "react-router-dom"
import './common.css'
import API_URL from '../common/Apiurl';
import SuccessMessage from '../common/Message';

function Editcategory(){
    const apiUrl = API_URL;
    const [items, setItems]=useState([]);
    const [industryitems, setIndustryitems]=useState([]);
    const [industryValue, setIndustryValue]=useState('');
    const getParam = useParams();
    const getcategoryid = getParam.categoryid;
    const [successMessages, setSuccessMessages] = useState([]);
    const [putdata, setPutdata]=useState('');
    const [addkey, setaddkey] = useState('');
    const [upaddkey, setUpaddkey] = useState('');
    const [selectedOptions, setSelectedOptions]=useState([]);
    useEffect(()=>{
        const getindustry = async (e) => {
            try{
                const postData = {
                    cat_id: getcategoryid
                };
                const result = await fetch(`${apiUrl}/admin/editcategorylist`,{
                    method: "POST",
                    headers:{
                        "Content-Type":"application/json",
                        "Accept":"application/json"
                    },
                    body:JSON.stringify(postData)
                });
                const data = await result.json();
                if(data.status !== 200){
                    throw new Error('Data not found');
                }
                setIndustryitems(data.data.industrylist);
                setSelectedOptions(data.data.selectedInd);
                setPutdata(data.data);
                setItems(data.data.categoryname);
                setaddkey(data.data.keywords)
            }
            catch(error){
                console.error('Error ', error)
            }
        };
        getindustry();
    }, []);

    const newaddkey = (e) => {
        setaddkey(e.target.value)
        setUpaddkey(e.target.value);
    }

    const updateCategory = async(e) => {
        e.preventDefault();
        let indVal = putdata.industryid;
        let sendindvalue = '';
        if(industryValue == ''){
            sendindvalue = indVal[0]
        }
        else{
            sendindvalue = industryValue
        }
        try{
            const postData = {
                cat_id: getcategoryid,
                category_name: items,
                // industry_id: sendindvalue,
                industry_id: selectedOptions,
                keywords: upaddkey
            }
            console.log(postData);
            const result = await fetch(`${apiUrl}/admin/updatecategory`, {
                method: "POST",
                headers: {
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body:JSON.stringify(postData)
            })
            const data = await result.json();
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }
        catch(error){
            console.log('Error: ', error)
        }
    }
    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
        window.location.reload();
    }
    const handleOption = (e) =>{
        var getValue = (e.target.value);
        if(selectedOptions.includes(getValue)){
            setSelectedOptions(selectedOptions.filter((data)=>data!=getValue));
        }else{
            setSelectedOptions([...selectedOptions, getValue]);
        }
    }
    return (
        <div className='width90'>
            <h2 className='pageTitle'>Edit Category</h2>
            <div className='commonCntr'>
                <form className="form-horizontal" onSubmit={updateCategory}>
                    <div className="form-group">
                        <label className="control-label col-sm-2 label" htmlFor="categoryname">Category Name:</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" id="categoryname" value={items} onChange={(e)=>setItems(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group mt-5">
                        <label className="control-label col-sm-2 label" htmlFor="industrytype">Industry Type:</label>
                        {/* <select className="form-select col-sm-5 selectBox" onChange={(e)=>setIndustryValue(e.target.value)}>
                            <option value={putdata.industryid}>{putdata.industryname}</option>
                            {industryitems.map((itemVal, index) => {
                                return(<option value={itemVal.indId}>{itemVal.indname}</option>
                            )})}
                        </select> */}
                        <select multiple className="form-select col-sm-5 selectBox" value={selectedOptions}  onChange={()=>{}}>
                            {industryitems.map((itemVal, index) => {
                                return(<option value={itemVal.indId} onClick={handleOption}>{itemVal.indname}</option>)
                                // <option value={inditem.industry_id}>{items.industryname}</option>
                            })}
                        </select>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label" htmlFor="categorykeywords">Add Keywords:</label>
                        <div className="col-sm-4">
                            <input type="text" onChange={(e)=>newaddkey(e)} className="form-control" id="categorykeywords" placeholder="keyword1, keyword2" value={addkey}/>
                        </div>
                        <span className='d-block mt-2'>Keywords must be comma separated</span>
                    </div>
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            <button type="submit" className="btn btn-default submitBtn">Submit</button>
                        </div>
                    </div>
                </form>
                {
                    successMessages.map((message, index) => (
                        <SuccessMessage
                            key={index} 
                            message = {message} 
                            onFadeOut={handleSuccessMessageFadeOut}
                        />
                    )
                )}
            </div>
        </div>
    )
}

export default Editcategory;